export const ERROR_ICON_PATH = 'assets/images/result/error.svg';

export type Outcome = 'success' | 'error';
export type OptionsType = 'reason' | 'detail';
export type FigureType = 'TOMADOR' | 'ASEGURADO' | 'TITULAR';

export interface IsNonRenewalAlreadyRequestedResponse {
  cancellable: boolean;
  description?: string;
  cancellationDate?: string;
}

export interface NonRenewalRequest {
  attachments: Document[];
  userId: string;
  companyCode: string;
  description: string;
  reason: string;
  detail: string;
  portal: string;
  policyType: string;
}

export interface NonRenewalRequestedResponse {
  result: string;
  cancellationDate: string;
  description: string;
}

export interface NRDetail {
  documentsToAttach?: string[];
  id: string;
  selected?: boolean;
  pdp: boolean;
}

export interface NonRenewalContextState {
  isSusceptibleToNonRenewal: boolean;
  closeExpansionPanel: boolean;
  docs: Document[];
  reason: ReasonConf;
  detail: DetailConf;
  description: string;
  isSusceptible: boolean;
  isSusceptibleCached: boolean;
  paymentPlanInfoContent: PaymentPlanInfoContent;
  canceledProcess: boolean;
}

export interface Document {
  name?: string;
  content?: string;
  documentId?: string;
  fullname?: string;
  mimeType?: string;
  base64Content?: string;
  size?: number;
  type?: string;
}

export interface PaymentPlanInfoContent {
  message: string;
  subMessage: string;
  cancelBtnText: string;
  callBtnText: string;
  phoneNumber: string;
  loaded: boolean;
}

export interface NonRenewalROParams {
  entityCode: string;
  codProduct: string;
  productId: string;
  group: string;
  email: string;
  documentNumber: string;
}

export interface DocToAttach {
  info: string;
  id: string;
}

export interface NRConfig {
  active: boolean;
  autoResendFailedServices: boolean;
  customConfig: NonRenewalCustomConfig;
}

export interface NonRenewalCustomConfig {
  nonRenewal: NonRenewalConfig;
}

export interface NonRenewalConfig {
  commonReasons: CommonReason[];
  policies: PolicyConf[];
  text: Text;
}

export interface Text {
  reasons: { [key: string]: string };
  details: { [key: string]: string };
  documents_to_attach: { [key: string]: string };
  info: { [key: string]: string };
}

export interface PolicyConf {
  CIAS: string[];
  RAMO: string[];
  figure: FigureType[];
  commonReasons: boolean;
  reasons: ReasonConf[];
  visibleMETS: boolean;
  type:
    | 'accidentes'
    | 'animales'
    | 'autos'
    | 'comercios'
    | 'decesos'
    | 'salud'
    | 'vida_riesgo'
    | 'salud_indemnizacion'
    | 'otros'
    | 'hogar'
    | 'autonomos1'
    | 'autonomos2'
    | 'autonomos3';
}

export interface ReasonConf {
  details: DetailConf[];
  id: string;
  pdp: boolean;
  documentsToAttach: string[] | DocToAttach[];
  selected?: boolean;
}

export interface CommonReason {
  details: DetailConf[];
  id: string;
}

export interface DetailConf {
  id: string;
  pdp: boolean;
  documentsToAttach?: string[] | DocToAttach[];
}

export interface ErrorData {
  title: string;
  text1: string;
  text2?: string;
  primaryBtnTxt: string;
  secondaryBtnTxt?: string;
}

export enum NonRenewalStatus {
  VALID = 'VALID',
  EXPIRED = 'EXPIRED',
  NON_VALID = 'NON_VALID',
  ALREADY_REQUESTED = 'ALREADY_REQUESTED',
  IN_FORCE = 'VIGOR',
  LOW_EXPIRATION = 'BAJA VENCIMIENTO'
}

export enum NonRenewalRounting {
  HOME = 'client-area/home',
  CLIENT_AREA_ERROR = 'client-area/product-error',
  BLOCK_KEY_ERROR = 'bank-data/error-blocked-sign-key',
  BASE_PATH = 'non-renewal/',
  REQUEST_SEND = 'request-sent/',
  REASONS = 'reasons',
  REASONS_LIST = 'reasons-list',
  ATTACH_INFO = 'attach-info',
  PAYMENT_PLAN_INFO = 'payment-plan-info',
  PAYMENT_PLAN = 'payment-plan/info',
  CONFIRM_SIGNING = 'confirm-signing-key',
  ERROR = 'non-renewal-error'
}

export enum NonRenewalLoadingId {
  NR_CONFIG = 'nonrenwal-config',
  PAYMENT_PLAN_SUSCEPTIBILITY = 'payment-plan-susceptibility',
  SEND_NON_RENEWAL_REQUEST = 'send-non-renewal-request',
  VALIDATE_KEY = 'validate-signature-key-status',
  VALIDATE_SIGNING_KEY = 'validating-signin-Key',
  SUSCEPTIBLE_STATUS = 'susceptible-status',
  REQUIRED_POSITIONS = 'signing-key-required-positions',
  BLOCK_KEY = 'block-key'
}

export enum PolicyTypeRequest {
  AC = 'accidentes',
  AN = 'animales',
  AT = 'autos',
  C = 'comercios',
  D = 'decesos',
  H = 'hogar',
  S = 'salud',
  AU = 'autonomos',
  V = 'vida_riesgo',
  OT = 'otros'
}
